import { render, staticRenderFns } from "./DemoTextfieldIcons.vue?vue&type=template&id=00cd5664&"
import script from "./DemoTextfieldIcons.vue?vue&type=script&lang=js&"
export * from "./DemoTextfieldIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
